export const VOIVODESHIPS = [
  "LOWER_SILESIAN",
  "KUYAVIAN_POMERANIAN",
  "LUBLIN",
  "LUBUSZ",
  "LODZ",
  "LESSER_POLAND",
  "MASOVIAN",
  "OPOLE",
  "SUBCARPATHIAN",
  "PODLASKIE",
  "POMERANIAN",
  "SILESIAN",
  "HOLY_CROSS",
  "WARMIAN_MASURIAN",
  "GREATER_POLAND",
  "WEST_POMERANIAN",
] as const;
